module.exports = __webpack_public_path__ + "media/src/images/partners/udima-3c0bc321cfa47f658614e84315d1f6ae.jpg";